import { PrivateInterceptor } from '../../../interceptors/PrivateInterceptor'
import { PublicInterceptor } from '../../../interceptors/PublicInterceptor';

export const getUsuarios = async() => {
    const result = await PrivateInterceptor(`IT/Users`, 'GET')
    return result;
}

export const getUsuariosA = async(IdStatus) => {
    console.log(IdStatus);
    
    const result = await PrivateInterceptor(`IT/Users/Status/${IdStatus}`, 'GET')
    return result;
}

export const getUsuariosActivos = async() => {
    const result = await PrivateInterceptor(`IT/Users/Activos`, 'GET')
    return result;
}

export const getUsuariosActivosToken = async(Token) => {
    const result = await PublicInterceptor(`IT/Users/Activos`, 'GET',{}, Token)
    return result;
}

// OBTIENE LA CONTRA DEL USUARIO
export const getPassUser = async (data) => {
    const result = await PrivateInterceptor(`IT/Users/getPassUser`, 'POST', {data})
    return result;
}

// MODIFICA UN USUARIO
export const updateUser = async(user) => {
    const respuesta = await PrivateInterceptor(`IT/Users`, 'PUT', user)
    return respuesta;
}

// MODIFICAR CONTRASEÑA DE UN USUARIO
export const updatePassword = async(user) => {
    const respuesta = await PrivateInterceptor(`IT/Users/password`, 'PUT', user)
    return respuesta;
}

// AGREGAR UN USUARIO
export const addUser = async(user) => {
    const respuesta = await PrivateInterceptor(`IT/Users`, 'POST', user)
    return respuesta;
}

//OBTENER FIRMA
export const getFirmasPersonales = async (Codigo) => {
    const respuesta = await PrivateInterceptor(`IT/Users/getFirma/` + Codigo, 'GET')
    return respuesta;
}

export const descargarFirma = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`IT/Users/getFile/${Codigo}/${nombre}`, 'GET')
    return respuesta;
}

export const eliminarFirma = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`IT/Users/deleteFile/${Codigo}/${nombre}`, 'DELETE')
    return respuesta;
}

export const mostrarFirma = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`IT/Users/getFile/${Codigo}/${nombre}`, 'GET')
    var binary = '';
    var bytes = [].slice.call(new Uint8Array(respuesta.data));
    bytes.forEach((b) => binary += String.fromCharCode(b));
    const base64String = window.btoa(binary);
    return base64String;
}

